export function getFullName({firstName, lastName}: {firstName?: string | undefined; lastName?: string | undefined}) {
	return [firstName, lastName].filter(Boolean).join(' ').trim();
}
